<template>
  <div>
    <footer class="footer">
      <div class="footer-middle">
        <div class="container">
          <div class="row">
            <div :class="classColumn + ''">
              <div class="text-md-left text-center">
                <h4 class="widget-title">{{ data.title }}</h4>
                <!-- End .widget-title -->
                <p class="d-flex justify-content-center">
                  <!-- text-md-left text-center -->
                  {{ data.description }}
                </p>

                <div
                  class="social-icons d-flex justify-content-center justify-content-md-start"
                >
                  <a
                    href="https://it.linkedin.com/company/neurohub-it?trk=public_post_feed-actor-name"
                    class="social-icon"
                    title="linkedin"
                    target="_blank"
                    ><i class="icon-linkedin-in"></i
                  ></a>
                </div>
                <!-- End .soial-icons -->
              </div>
              <!-- End .widget about-widget -->
            </div>
            <!-- End .col-sm-6 col-lg-3 -->

            <div :class="classColumn">
              <!-- d-flex justify-content-center justify-content-md-start -->
              <div class="widget">
                <h4 class="widget-title text-md-left text-center">
                  Link utili
                </h4>
                <!-- End .widget-title -->

                <ul class="widget-list text-md-left text-center">
                  <li v-if="auth">
                    <router-link to="/casi-clinici">Casi clinici</router-link>
                  </li>
                  <li v-if="auth">
                    <router-link to="/forum">Forum</router-link>
                  </li>
                  <li v-if="auth">
                    <router-link to="/meeting">E-meeting</router-link>
                  </li>
                  <li v-if="auth">
                    <router-link to="/library">Biblioteca</router-link>
                  </li>
                  <li v-if="auth">
                    <router-link to="/presentation">Presentazioni</router-link>
                  </li>

                  <li v-if="auth">
                    <router-link to="">Account</router-link>
                  </li>

                  <li><router-link to="/">Log in</router-link></li>
                  <li>
                    <router-link to="/register">Registrati</router-link>
                  </li>
                </ul>
                <!-- End .widget-list -->
              </div>
              <!-- End .widget -->
            </div>
            <!-- End .col-sm-6 col-lg-3 -->

            <div :class="classColumn">
              <div class="widget">
                <h4 class="widget-title text-md-left text-center">
                  Termini e privacy
                </h4>
                <!-- End .widget-title -->

                <ul class="widget-list text-md-left text-center">
                  <li v-for="(page, key) in pages" :key="key">
                    <a :href="'/neurohub/' + page">{{ key }}</a>
                  </li>
                </ul>
                <!-- End .widget-list -->
              </div>
              <!-- End .widget -->
            </div>
            <!-- End .col-sm-6 col-lg-3 -->

            <div class="col-sm-6 col-lg-3" v-if="auth">
              <div class="widget">
                <h4 class="widget-title text-md-left text-center">
                  Il tuo account
                </h4>
                <!-- End .widget-title -->
                <ul class="widget-list text-md-left text-center">
                  <li>
                    <router-link to="/profile">Il mio profilo</router-link>
                  </li>
                </ul>
                <!-- End .widget-list -->
              </div>
              <!-- End .widget -->
            </div>
            <!-- End .col-sm-6 col-lg-3 -->
          </div>
          <!-- End .row -->
        </div>
        <!-- End .container -->
      </div>
      <!-- End .footer-middle -->

      <div class="footer-bottom">
        <div class="container">
          <p class="footer-copyright">
            Copyright © 2021 Neurohub. All Rights Reserved.
          </p>
          <!-- End .footer-copyright -->
        </div>
        <!-- End .container -->
      </div>
      <!-- End .footer-bottom -->
    </footer>
    <!-- End .footer -->

    <div class="mobile-menu-container">
      <div class="mobile-menu-wrapper">
        <span class="mobile-menu-close" @click="closeMenu"
          ><i class="icon-close"></i
        ></span>

        <nav class="mobile-nav">
          <ul class="mobile-menu">
            <li>
              <router-link to="/dashboard" @click="closeMenu">Home</router-link>
            </li>

            <li>
              <router-link to="/casi-clinici" @click="closeMenu"
                >Casi clinici</router-link
              >
            </li>
            <li>
              <router-link to="/forum" @click="closeMenu">Forum</router-link>
            </li>
            <li>
              <router-link to="/meeting" @click="closeMenu"
                >E-meeting</router-link
              >
            </li>
            <li>
              <router-link to="/library" @click="closeMenu"
                >Biblioteca</router-link
              >
            </li>
            <li>
              <router-link to="/presentation" @click="closeMenu"
                >Presentazioni</router-link
              >
            </li>
            <li>
              <router-link to="/profile" @click="closeMenu"
                >Il tuo profilo</router-link
              >
            </li>

            <li v-if="isAdmin">
              <a :href="adminDomain" target="_blank">Amministrazione</a>
            </li>

            <li>
              <!-- <router-link to="/account">Account</router-link> -->
            </li>
          </ul>
        </nav>
        <!-- End .mobile-nav -->

        <div class="social-icons">
          <a
            href="#"
            class="social-icon social-facebook text-dark"
            title="Facebook"
            target="_blank"
            ><i class="icon-linkedin"></i
          ></a>
        </div>
        <!-- End .social-icons -->
      </div>
      <!-- End .mobile-menu-wrapper -->
    </div>
    <!-- End .mobile-menu-container -->
  </div>
</template>
 
<script>
import axios from "axios";
import $ from "jquery";
window.jQuery = $;
window.$ = $;

export default {
  name: "FooterComponent",
  props: ["auth"],
  data() {
    return {
      classColumn: "",
      data: [],
      pages: [],
      adminDomain: "",
      isAdmin: false,
    };
  },
  mounted() {
    if (this.auth) {
      this.classColumn = "col-sm-6 col-lg-3";
    } else {
      this.classColumn = "col-sm-6 col-lg-3";
    }
    this.getImage();
    this.getStaticPage();
  },
  methods: {
    async getStaticPage() {
      await axios
        .post(
          "https://superadmin.neurohub.it/api/all-hidden-pages",
          {
            website: "https://neurohub.it/",
            slug: "login",
          },
          {
            headers: {
              Authorization: "ae0b35b6f4a58fdbc960dc7e7f9ba362",
              "Content-Type": "application/json",
              sourcehosting: "https://neurohub.it/",
            },
          }
        )
        .then((response) => {
          this.pages = response.data;
        })
        .catch(() => {
          console.log("Non si sono caricate le pagine statice");
        });
    },
    closeMenu() {
      $("body").removeClass("mmenu-active");
      $(".menu-toggler").removeClass("active");
    },
    async getImage() {
      await axios
        .post(
          "https://superadmin.neurohub.it/api/dinamic-pages",
          {
            website: "https://neurohub.it/",
            slug: "login",
          },
          {
            headers: {
              Authorization: "ae0b35b6f4a58fdbc960dc7e7f9ba362",
              "Content-Type": "application/json",
              sourcehosting: "https://neurohub.it/",
            },
          }
        )
        .then((response) => {
          this.data = response.data.content[0];
        })
        .catch(function (error) {
          console.log("errore resposnse" + error);
        });
    },
  },
};
</script>